import { Box, Typography } from '@mui/material';

type SwitchLabelTextProps = {
  label: string;
  description: string;
};

export const SwitchLabelText = ({
  label,
  description,
}: SwitchLabelTextProps) => (
  <Box>
    <Typography variant="body2" sx={{ fontWeight: 500, lineHeight: 1.2 }}>
      {label}
    </Typography>
    <Typography
      variant="caption"
      sx={{
        color: 'text.secondary',
        display: 'block',
        lineHeight: 1.3,
        whiteSpace: 'normal',
      }}
    >
      {description}
    </Typography>
  </Box>
);
